import { create } from "zustand";

export type ActualsTabKey =
  | "data-source-info"
  | "common-equity"
  | "preferred-equity"
  | "convertibles"
  | "cash"
  | "debt"
  | "debt-equivalents";

interface ActualsState {
  activeTab: ActualsTabKey;
  setActiveTab: (key: ActualsTabKey) => void;
}

export const useActualsStore = create<ActualsState>((set) => ({
  activeTab: "preferred-equity",
  setActiveTab: (key) => set({ activeTab: key }),
}));
